export const PC_BREAKPOINT_WIDTH = 1025 // pc ( resolution > 1024 )
export const PAD_BREAKPOINT_WIDTH = 640 // tablet ( 640 <= resolution < 1024 )
export const MOBILE_BREAKPOINT_WIDTH = 639; // mobile ( resolution < 640 )
export const MINI_MOBILE_BREAKPOINT_WIDTH = 400; // mini mobile ( resolution < 400 )
